import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-barcode-dialog',
  templateUrl: './barcode-dialog.component.html',
  styleUrls: ['./barcode-dialog.component.scss'],
  standalone: false
})
export class BarcodeDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<BarcodeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: BarcodeDialogData) { }

  ngOnInit(): void {
  }

  close(): void {
    this.dialogRef.close(false);
  }
}

export interface BarcodeDialogData {
  barcode: string;
}
